export default __webpack_public_path__ + "static/media/klaus.9d217500.png";